import React from 'react';
import { observer } from 'mobx-react';
import { Trans } from 'react-i18next';

import { Link } from 'core/routing';

import { useAppManager } from 'apps/hooks';
import { clientStore } from 'apps/client/app';

import ProjectsAppManager from 'apps/projects/appManager';
import Button from 'components/Button';
import { CardSection } from 'legacyComponents/layout/cardSection';
import { ProjectCard } from 'legacyComponents/cards/types/project';

const Projects = observer(({ maxItems }) => {
  const shouldCreate = !!clientStore.signedInProfile;
  const appManager = useAppManager(ProjectsAppManager, null, {}, shouldCreate);

  if (!clientStore.signedInProfile) return null;

  const projectsConnection = appManager.projectsConn;
  if (!projectsConnection) return null;
  const projects = projectsConnection.arrayApp;

  let numItems = projects?.length;
  if (!numItems) numItems = 0;

  let actions = null;
  if (numItems > 0) {
    actions = (
      <Link name='home.newProject'>
        <Button
          text={<Trans>New Project</Trans>}
          size='small'
          icon='add'
          iconPosition='right'
        />
      </Link>
    );
  }

  const { activeSpace } = clientStore;
  const title =
    activeSpace?.spaceType === 'INITIATIVE' ? `Projects` : 'My Projects';

  return (
    <>
      <CardSection
        invisible={appManager.loading}
        title={title}
        subTitle=' '
        tooltip='Create new Project.'
        isOwnProfile={false}
        owner
        ownerName={clientStore.signedInProfile.user.fullName}
        cardApp={projects}
        CardComponent={ProjectCard}
        noDataCardType='homeProject'
        gridColumns={3}
        actions={actions}
        maxItems={maxItems}
        showAllRouteName='workspace.spaceProjects'
        showAllRouteParams={{ spacePath: clientStore.activeSpace?.path }}
      />
    </>
  );
});

export default Projects;
